/* eslint-disable react/no-unused-prop-types */
import React, { useState, useCallback } from 'react';
import { IconActionInfo, IconActionAbout } from '@cko/icons';
import { Tooltip, TextStatus, Flex } from '@cko/primitives';
import styled from 'styled-components';
const InfoIcon = styled(IconActionInfo) `
  vertical-align: text-top;
`;
const Icons = {
    info: IconActionInfo,
    help: IconActionAbout,
};
const TooltipContainer = ({ text, children, defaultDirection, ...props }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const showTooltipOnMouseEnter = useCallback(() => setShowTooltip(true), []);
    const hideTooltipOnMouseLeave = useCallback(() => setShowTooltip(false), []);
    return (React.createElement(Tooltip, { text: text, show: showTooltip, defaultDirection: defaultDirection, ...props },
        React.createElement("div", { onMouseEnter: showTooltipOnMouseEnter, onMouseLeave: hideTooltipOnMouseLeave }, children)));
};
export const InfoTooltip = ({ text, testId }) => (React.createElement(TooltipContainer, { text: text },
    React.createElement(InfoIcon, { "data-testid": testId, fill: "var(--control-icon-secondary)" })));
export const StatusTooltip = (props) => {
    const { text, type = 'default', children } = props;
    return text ? (React.createElement(TooltipContainer, { text: text },
        React.createElement(TextStatus, { interactive: false, type: type }, children))) : (React.createElement(TextStatus, { interactive: false, type: type }, children));
};
const Icon = React.memo((props) => React.createElement(Icons[props.type]));
export const TooltipWithOptions = ({ defaultDirection = 'bottom', testId, tooltipText, type = 'info', }) => (React.createElement(TooltipContainer, { text: tooltipText, defaultDirection: defaultDirection },
    React.createElement(Flex, { justifyContent: "center", alignItems: "center", height: "100%", "data-testid": testId },
        React.createElement(Icon, { type: type }))));
export default TooltipContainer;
